module.exports = __webpack_public_path__ + "img/TXT.16831353.svg";